import { createCustomEnum } from "./customEnum";

export const DealStage = createCustomEnum({
	Application: {
		value: "0",
		name: "Application",
		displayName: "Application",
	},
	Underwriting: {
		value: "1",
		name: "Underwriting",
		displayName: "Underwriting",
	},
	MPAUpload: {
		value: "2",
		name: "MPAUpload",
		displayName: "MPA Upload",
	},

	AddScheduleA: {
		value: "3",
		name: "AddScheduleA",
		displayName: "Add ScheduleA",
	},
});
